<template>
  <div>
    <div class="row">
      <div class="col-auto"><!-- cerca -->
        <search-box v-model="searchQuery.searchTerm"></search-box>
      </div>
      <div class="col-auto"><!-- destinazione -->
        <destination-box
          v-model="searchQuery.destinazione"
          category-name="Destinazione"
        ></destination-box>
      </div>
      <div class="col-auto">
        <!-- comune -->
        <label for="select-comune">Comune</label>
        <city-combo
          v-model="searchQuery.comune"
          @city="value => searchQuery.comune = value"
        />
      </div>
      <div class="col-auto"><!-- provincia -->
        <province-combo v-model="searchQuery.provincia"></province-combo>
      </div>
      <div class="col-auto">
        <!-- lingua -->
        <lang-box v-model="searchQuery.lang"></lang-box>
      </div>
      <div class="col-auto"><!-- stato -->
        <statuses-box list="true" v-model="searchQuery.stato" ></statuses-box>
      </div>
      <div class="col-auto"><!-- pulsanti azione -->
        <label>Azioni</label>
        <div class="btn-toolbar mr-2" role="toolbar" aria-label="Bottoni azione">
          <div class="btn-group mb-2 mr-2" role="group" aria-label="Azioni">
            <button class="btn btn-primary" @click="filter()"><i class="ti ti-filter"></i> Filtra</button>
            <button class="btn btn-default" @click="noFilter()"><i class="ti ti-arrow-circle-up"></i>
              Annulla Filtri
            </button>
          </div>
          <router-link
            tag="button"
            type="button"
            class="btn mb-2 btn-success"
            :to="{ name: 'Gestione Località', params: {id:'new'} }" v-if="entity_create">
            <i class="ti ti-plus"></i> Nuova Località
          </router-link>
        </div>
      </div>
    </div><!-- ./filtri -->
    <div class="card">
      <vue-good-table
        ref="generic-table"
        mode="remote"
        styleClass="vgt-table striped"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :columns="columns"
        :rows="rows"
        totalRecords
        :paginate="true"
        :lineNumbers="false"
        :pagination-options="{
                                    enabled: true,
                                    position: 'top',
                                    nextLabel: 'Successivo',
                                    prevLabel: 'Precedente',
                                    rowsPerPageLabel: 'Righe per pagina',
                                    dropdownAllowAll: false,
                                    perPage: serverParams.pagination.currentPerPage,
                                    perPageDropdown: serverParams.myPerPageDropdown,
                                    setCurrentPage: serverParams.page
                    }"
        :sort-options="{ enabled: true, }"
        :selectOptions="{
                                    enabled: entity_delete,
                                    selectOnCheckboxOnly: true,
                                    selectionInfoClass: 'generic-class',
                                    selectionText: 'righe selezionate',
                                    clearSelectionText: 'deseleziona',
                    }"
        :isLoading="isLoading"
      >
        <div slot="emptystate" id="emptystate" v-if="totalRecords == 0">
          <div class="vgt-center-align vgt-text-disabled">
            <span v-if="!isLoading">Nessun risultato disponibile</span>
          </div>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <action-table name="Gestione Località"
                          :path="table1.route"
                          :id="props.row.id"
                          :draft="props.row.draft"
                          :revision="props.row.revision">
            </action-table>
          </span>
          <span v-else-if="props.column.field == 'flag'">
           <flag-available-content-language :align="1"
                                            :contents="props.row.contents"></flag-available-content-language>
          </span>
          <span v-else-if="props.column.field == 'status'">
            <ul class="lists">
              <li v-for="(lang, langIndex) in langs" :key="langIndex">
                <statuses-span :contents="props.row.revision_statuses[lang] ? props.row.revision_statuses[lang].status : props.row.contents[lang].status"></statuses-span>
              </li>
            </ul>                    </span>
          <span v-else><!-- id / titolo / comune -->
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>

        <div slot="selected-row-actions">
          <a v-on:click="deleteAll()" v-if="entity_delete">
            <button class="btn btn-primary">Cancella Selezionati</button>
          </a>
        </div>
      </vue-good-table>
      <!-- chiusura componente -->
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  
  import SearchBox from "@/components/altrama/SearchBox";
  import CategoryBox from "@/components/altrama/CategoryBox";
  import ProvinceCombo from "@/components/altrama/ProvinceCombo";
  import StatusesBox from "@/components/altrama/StatusesBox";
  import DestinationBox from "@/components/altrama/DestinationBox";
  import StatusesSpan from "@/components/altrama/StatusesSpan";
  import CityCombo from "@/components/altrama/CityCombo";
  import LangBox from "@/components/altrama/LangBox";

  const tableColumns = ["id", "cognome", "email"]; //mantenere per i campi tolowercase header tabella
  const tableData = [];

  export default {
    components: {
      SearchBox,
      CategoryBox,
      ProvinceCombo,
      StatusesBox,
      DestinationBox,
      StatusesSpan,
      CityCombo,
      LangBox
    },
    data() {
      return {
        table1: {
          title: "Elenco",
          subTitle: "",
          columns: [...tableColumns],
          data: [...tableData],
          route: "localita",
        },

        columns: [
          {
            label: "ID",
            field: "id",
            type: "number",
            html: false,
            tdClass: "text-center",
            thClass: "text-center",
            sortable: true
          },
          {
            label: "TITOLO",
            field: "title",
            filterable: false,
            sortable: false
          },
          {
            label: "COMUNE",
            field: "city",
            filterable: false,
            sortable: false
          },
          {
            label: 'PROVINCIA',
            field: 'province',
            filterable: false,
            html: true,
            sortable: true
          },
          {
            label: 'STATO',
            field: 'status',
            html: true,
            tdClass: 'text-left',
            thClass: 'text-left',
          },
          {
            label: "LINGUA",
            field: "flag",
            filterable: false,
            html: true,
            tdClass: "text-center",
            thClass: "text-center",
            sortable: false
          },
          {
            label: "AZIONI",
            field: "action",
            filterable: false,
            html: true,
            tdClass: "text-center",
            thClass: "text-center",
            sortable: false
          }
        ],
        entity_create: false,
        entity_delete: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "id",
            type: "desc"
          },
          pagination: {
            currentPage: 1,
            currentPerPage: 50
          },
          myPerPageDropdown: [10, 20, 30, 40, 50]
        },
        isLoading: false,
        searchQuery: {
          'searchTerm': '',
          'provincia': -1,
          'comune': {'id': null},
          'destinazione': {'id': null},
          'stato': -1,
          'lang': 'all'
        },
        langs: ['it', 'en'],
      };
    },
    created: function () {
      if (this.$api.user.can("localita-view") == false) {
        this.$router.replace("/not-found");
        return;
      }
      this.entity_create = this.$api.user.can("localita-create");
      this.entity_delete = this.$api.user.can("localita-delete");
    },

    mounted: function () {
      if (localStorage.getItem('localita_searchQuery')) { // parametri di ricerca
        this.searchQuery = this.getSearchFilter();
      }
      if (localStorage.getItem('localita_serverParams')) { // parametri di tabella
        this.serverParams = this.getParameterFilter();
      }
      this.updateResource();
    },
    methods: {
      filter() {
        this.serverParams.pagination.currentPage = 1;
        this.updateResource();
      },

      noFilter() {
        localStorage.removeItem("itinerari_searchQuery");
        localStorage.removeItem("itinerari_serverParams");

        this.serverParams = {
          columnFilters: {},
          sort: {
            field: "id",
            type: "desc"
          },
          pagination: {
            currentPage: 1,
            currentPerPage: 50
          },
          myPerPageDropdown: [10, 20, 30, 40, 50]
        };

        this.searchQuery = {
            'searchTerm': '',
            'provincia': -1,
            'comune': {'id': null},
            'destinazione': {'id': null},
            'lang': 'all'
        }

        const query = this.searchQuery;
        for (var key in query) {
          query[key] = {'id': null};
        }
        query['searchTerm'] = '';
        query['provincia'] = -1;
        //query['stato'] = -1;
        query['lang'] = "all";

        this.updateResource();
      },
      saveParameterFilter() {
        localStorage.setItem(
          "localita_searchQuery",
          JSON.stringify(this.searchQuery)
        );
        localStorage.setItem(
          "localita_serverParams",
          JSON.stringify(this.serverParams)
        );
      },
      saveSearchFilter() { // salva parametri di ricerca
        localStorage.setItem('localita_searchQuery', JSON.stringify(this.searchQuery));
      },
      getSearchFilter() { // prende parametri di ricerca
        return JSON.parse(localStorage.getItem('localita_searchQuery'));
      },
      getParameterFilter() { // prende parametri di tabella
        return JSON.parse(localStorage.getItem('localita_serverParams'));
      },
      onPerPageChange(params) { // risultati per pagina
        console.log('onPerPageChange');
        console.log(params);
        this.serverParams.pagination = params;
        this.updateResource();
      },
      onPageChange(params) { // risultati nel numero di pagina della paginazione (Es: pag 2 di 5)
        console.log('onPageChange');
        console.log(params);
        this.serverParams.pagination = params;
        this.updateResource();
      },
      onSortChange(params) { // ordinamento risultati per campo
        console.log('onSortChange');
        console.log(params[0]);
        this.serverParams.sort = params[0];
        this.updateResource();
      },

      updateResource() {
        let self = this;
        self.rows = [];
        self.isLoading = true;

        var typeSort = "+";
        if (this.serverParams.sort.type == "desc") {
          typeSort = "-";
        }

        this.saveParameterFilter();

        axios({
          method: "GET",
          url: this.$url + "localita-ert",
          headers: this.$config.axiosHeaders(),
          params: {
            keywords: self.searchQuery.searchTerm,
            destinazione: self.searchQuery.destinazione ? self.searchQuery.destinazione.id : -1,
            provincia: self.searchQuery.provincia,
            comune: self.searchQuery.comune ? self.searchQuery.comune.id : -1,
            lang: self.searchQuery.lang,
            stato: self.searchQuery.stato,
            orderBy: typeSort + self.serverParams.sort.field,
            page: self.serverParams.pagination.currentPage,
            limit: self.serverParams.pagination.currentPerPage
          }
        }).then(function (response) {
          self.totalRecords = response.data.meta.total;
          self.rows = [];
          var obj = response.data.data;

          for( let entity of obj){  

            self.rows.push({
              id: entity.id,
              title: entity.contents["it"].DENOMINAZIONE,
              city: entity.comune != null ? entity.comune.city : 'assente',
              province: entity.comune != null ? entity.comune.province : 'assente',
              contents: entity.contents,
              draft: entity.draft,
              revision: entity.revision,
              revision_statuses: entity.revision_statuses

            });
          }
        }).catch(function (error) {
          
          self.$processError(error);
        }).finally(
          () => self.isLoading = false
        );
      },

      deleteAll: function () {
        if (confirm('Confermare cancellazione degli elementi selezionati?')) {
          var elenco = [];
          var selected = this.$refs['generic-table'].selectedRows;
          for (var i = 0; i < selected.length; i++) {
            elenco.push(selected[i].id);
          }
          var self = this;
          self.isLoading = true;

          axios({
            method: 'DELETE',
            url: this.$url + "localita-ert" + '/' + elenco,
            headers: this.$config.axiosHeaders(),
          }).then(function (response) {
            self.$notifyVue('top', 'center', 'success', response.data.data.message, 'ti-check');
            self.updateResource();
          }).catch(function (error) {
            self.$processError(error);
            
          }).finally(
            () => self.isLoading = false
          );
        }
      },
    } // methods
  };
</script>
